import HORIZONTAL_PLP_CONSTANTS from './HorizontalCategory.constants';

const initialState = {
  isHorizontalPlpLoading: false,
  horizontalPlpProducts: [],
  horizontalPlpProductsSeoData: {},
};

const HorizontalCategoryReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case HORIZONTAL_PLP_CONSTANTS.RESET_HORIZONTAL_CATEGORY_PRODUCTS:
      return { ...state, horizontalPlpProducts: [] };
    case HORIZONTAL_PLP_CONSTANTS.SET_HORIZONTAL_CATEGORY_PRODUCTS:
      return { ...state, horizontalPlpProducts: action.payload };
    case HORIZONTAL_PLP_CONSTANTS.SET_HORIZONTAL_PLP_LOADING:
      return { ...state, isHorizontalPlpLoading: action.payload };
    case HORIZONTAL_PLP_CONSTANTS.SET_HLP_SUBCATEGORIES_FETCHED:
      return { ...state, subCategoryFetched: action.payload };
    case HORIZONTAL_PLP_CONSTANTS.SET_HLP_CID:
      return { ...state, currentCid: action.payload };
    case HORIZONTAL_PLP_CONSTANTS.SET_HORIZONTAL_SEO_DATA: {
      const { catId = '', seoHeaderCopy = '' } = action.payload;
      return {
        ...state,
        horizontalPlpProductsSeoData: {
          ...state.horizontalPlpProductsSeoData,
          [catId]: seoHeaderCopy,
        },
      };
    }
    case HORIZONTAL_PLP_CONSTANTS.CLEAR_HORIZONTAL_SEO_DATA:
      return { ...state, horizontalPlpProductsSeoData: {} };
    case HORIZONTAL_PLP_CONSTANTS.SET_HPLP_APPLIED_SORT_ID:
      return { ...state, appliedSortId: action.payload };
    case HORIZONTAL_PLP_CONSTANTS.SET_HPLP_FILTERS:
      return { ...state, filters: action.payload };
    case HORIZONTAL_PLP_CONSTANTS.SET_HPLP_APPLIED_FILTERS:
      return { ...state, appliedFilters: action.payload };
    case HORIZONTAL_PLP_CONSTANTS.SET_IS_HPLP:
      return { ...state, isHplp: action.payload };
    case HORIZONTAL_PLP_CONSTANTS.SET_HPLP_INITIAL_DATA_LOADING:
      return { ...state, isHplpInitialDataLoading: action.payload };
    default:
      return state;
  }
};

export default HorizontalCategoryReducer;
